import { ROUTES_CREATE_SESSION } from '@/constants/routes';
export default {
    path: '/create-session/:id?',
    name: ROUTES_CREATE_SESSION,
    meta: {
        requiresFocuses: true,
        requiresSpeedIntensities: true,
        requiresHeartRateIntensities: true,
        requiresStrokeRateIntensitiesRowing: true,
        requiresStrokeRateIntensitiesPaddling: true
    },
    component: () => import(/*webpackChunkName: 'create-session'*/ '@/views/CreateSession')
};
